import { render, staticRenderFns } from "./unused-comp_dpc-CarouselMultiple.vue?vue&type=template&id=646ca3de&scoped=true&"
import script from "./unused-comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
export * from "./unused-comp_dpc-CarouselMultiple.vue?vue&type=script&lang=js&"
import style0 from "./unused-comp_dpc-CarouselMultiple.vue?vue&type=style&index=0&id=646ca3de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ca3de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems})
